/*
Tape and Masking Paper
*/
import filters from '@/modules/standardItems/schemas/finish/filters'
import headers from '@/modules/standardItems/schemas/finish/headers'
import form from '@/modules/standardItems/schemas/finish/form'

const name = 'Tape and Masking Paper'
const id = 'zgNvdf8pqGg6en2uogd4'

export default {
  name,
  id,
  filters,
  headers,
  form
}
